import { DateTime } from 'luxon'
const $addDate = function (date = '', value, opt) {
  const { type = 'days', format = 'yyyy-MM-dd' } = { ...opt }

  const data = {}
  data[type] = value
  return DateTime.fromISO(date).plus(data).toFormat(format)
}
let addDate = {
  install: (app, options) => {
    app.config.globalProperties.$addDate = $addDate
    app.provide('addDate', $addDate)
  }
}

export default addDate
